var React = require('react');

function YellowClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.4818 0.14319L6.00098 4.62204L1.52116 0.14319C1.33511 -0.0428599 1.02437 -0.0428599 0.83248 0.149035L0.149647 0.82992C-0.051015 1.03156 -0.0441964 1.33255 0.143802 1.52055L4.62362 5.99939L0.143802 10.4802C-0.0422483 10.6662 -0.0422482 10.977 0.149647 11.1689L0.83248 11.8517C1.03217 12.0514 1.33316 12.0455 1.52116 11.8575L6.00098 7.37675L10.4818 11.8575C10.6668 12.0436 10.9786 12.0436 11.1704 11.8517L11.8533 11.1689C12.053 10.9692 12.0471 10.6682 11.8591 10.4802L7.37931 5.99939L11.8591 1.52055C12.0442 1.3345 12.0452 1.02182 11.8533 0.82992L11.1704 0.149035C11.0701 0.0487041 10.9454 0 10.8217 0C10.6961 0 10.5743 0.0487041 10.4818 0.14319Z","fill":"#FFCB08"}));
}

YellowClose.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = YellowClose;

YellowClose.default = YellowClose;
